import iconLibrary from "../../constants/iconLibrary";
import {
  RECOMMENDED_THIRDSERVICE,
  THIRDPARTIES_LIBRARY,
  ISOLATED,
} from "../../constants/constants";
import {
  getProductAndDadByProductId,
  getProductById,
} from "@/utils/dataHandlers/ProductDataHandler";
import {
  PROVIDER_ACTIVATION_URL,
  DISNEY_ACTIVATION_DPROVIDER_ACTIVATION_URL,
  DISNEY_LOGIN_URL,
} from "@/constants/project-urls";
import { PROVIDER_ID_APPLETV, PROVIDER_ID_DAZN, PROVIDER_ID_DISNEY, PROVIDER_ID_MAX, PROVIDER_ID_SKY } from "@/constants/tv";

export const THIRDPARTY_STATUS = {
  HIRED: "HIRED",
  RECOMMENDED: "RECOMMENDED",
};

/* reglas de juego en front */
export const addUsefulDataToServices = (
  thirdParties,
  kindProduct,
  bundle,
  productId
) => {
  const res = [];
  thirdParties.forEach((service) => {
    const newItem = { ...service };
    newItem.ballColor = "Blue";
    newItem.classIcon = iconLibrary.product;
    newItem.badge = false;
    const ballColor = service.status === "HIRED" ? "Blue" : "Green";

    newItem.ballColor = ballColor;
    if (service.serviceId === 1) {
      newItem.classIcon = iconLibrary.netflix;
    }
    if (service.serviceId === 3) {
      const csKind = kindProduct === "internet" ? "CONVERGENTE" : "MÓVIL";
      const hasHGU =
        bundle &&
        bundle.internet &&
        bundle.internet.device &&
        bundle.internet.device === "HGU";
      const ballColorCS =
        service.status === "RECOMMENDED" && csKind === "CONVERGENTE" && !hasHGU
          ? "Green"
          : "Blue";
      newItem.csKind = csKind;
      newItem.ballColor = ballColorCS;
      newItem.badge =
        service.status === "RECOMMENDED" && (csKind === "MÓVIL" || hasHGU);
      newItem.classIcon = iconLibrary.seguridad;
      newItem.link = `/misProductos/conexionSegura/${bundle.productId}`;
    }
    if (service.serviceId === 4) {
      newItem.classIcon = iconLibrary.movistarcloud;
      newItem.link = `/misProductos/sva/movistarCloud/${productId}`;
    }
    if (service.serviceId === 5) {
      newItem.classIcon = iconLibrary.movistarcar;
      newItem.link = `/misProductos/sva/movistarCar/${productId}`;
    }
    if (service.serviceId === 6) {
      newItem.classIcon = iconLibrary.soteira;
      newItem.classIcon2 = iconLibrary.soteira2;
      newItem.link = `/misProductos/sva/movistarProsegurAlarmas/${productId}`;
    }
    if (service.serviceId === 7) {
      newItem.classIcon = iconLibrary.qustodio;
      newItem.classIcon2 = iconLibrary.qustodio2;
      newItem.link = `/misProductos/sva/qustodio/${productId}`;
    }
    if (service.serviceId === 9) {
      newItem.badge = service.status !== THIRDPARTY_STATUS.HIRED;
      newItem.svgIcon = iconLibrary.ehealth;
      newItem.ballColor = "Blue";
      newItem.link = `/misProductos/sva/ehealth/${productId}`;
      newItem.serviceName = THIRDPARTIES_LIBRARY.eHealth.serviceName;
      if (service.status !== THIRDPARTY_STATUS.HIRED) {
        newItem.serviceName = `Contrata ${newItem.serviceName}`;
      }
    }

    res.push(newItem);
  });
  return res;
};

export const normalizeThirdParties = (rawData, hiredProducts) => {
  let res = null;

  if (rawData) {
    /* THIRD SERVICES WITHOUT DEPENDENCIES */
    res = {};
    const { productosConTerceros, tercerosSinDependencias } = rawData;
    res[ISOLATED] = [];
    tercerosSinDependencias.forEach((serviceItem) => {
      const newServiceItem = {
        ...serviceItem,
        status: THIRDPARTY_STATUS.HIRED,
      };
      const newThirdParties = addUsefulDataToServices(
        [newServiceItem],
        "",
        null,
        serviceItem.serviceId
      );
      if (newThirdParties && newThirdParties.length > 0) {
        res[ISOLATED].push(newThirdParties[0]);
      }
    });
    /* productos con terceros (lo de to la vida) */
    productosConTerceros.forEach((serviceItem) => {
      let { thirdParties } = serviceItem;
      thirdParties = thirdParties.map((item) => ({
        ...item,
        status: THIRDPARTY_STATUS.HIRED,
      }));
      hiredProducts.forEach((bundle) => {
        const { productId } = bundle;
        const { childProductId } = bundle;
        const itIsForMe = childProductId.find(
          (deviceItem) => deviceItem.productId === serviceItem.productId
        );
        if (itIsForMe) {
          const { kindProduct } = itIsForMe;
          if (!res[productId]) {
            res[productId] = {};
          }
          if (!res[productId][kindProduct]) {
            res[productId][kindProduct] = {};
          }
          const newThirdParties = addUsefulDataToServices(
            thirdParties,
            kindProduct,
            bundle,
            serviceItem.productId
          );
          if (newThirdParties && newThirdParties.length > 0) {
            res[productId][kindProduct][itIsForMe.productId] = newThirdParties;
          }
        }
      });
    });
  }
  return res;
};

/* appedn recomended services depends on bundle and delete those what i dont need */
export const appendRecommendedServicesDependsOnProductType = (
  thirdPartiesList,
  hiredProducts
) => {
  // see every RECOMMENDED
  let res = thirdPartiesList;
  if (!res) {
    res = {};
  }
  const keyBundles = hiredProducts.map((bundle) => bundle.productId);
  // see for every bundle
  keyBundles.forEach((keyBundle) => {
    const currentBundle = hiredProducts.find(
      (bundle) => bundle.productId === keyBundle
    );
    // if bundles exists.. i know this is obvious
    if (currentBundle) {
      const { productType, childProductId } = currentBundle;
      // now we now what it is my bundle type
      RECOMMENDED_THIRDSERVICE.forEach((itemRecommended) => {
        const { service, productTypes, kindProduct } = itemRecommended;
        const itIsMyTarget =
          service &&
          service.serviceId &&
          productTypes &&
          productTypes.indexOf(productType) > -1;
        if (itIsMyTarget && kindProduct) {
          let lastservices = thirdPartiesList[currentBundle.productId];
          // Checking if this kind of device has services
          if (!lastservices || (lastservices && !lastservices[kindProduct])) {
            if (!lastservices) {
              lastservices = {};
            }
            lastservices[kindProduct] = {};
            // getting ids...
            const myImportantChild = [];
            childProductId.forEach((child) => {
              if (child.kindProduct === kindProduct) {
                myImportantChild.push(child);
              }
            });
            myImportantChild.forEach((ichild) => {
              lastservices[kindProduct][ichild.productId] = [];
            });
          }
          lastservices = lastservices[kindProduct];
          // vemos los keys hijos que tiene
          const childKeys = Object.keys(lastservices);
          if (childKeys.length === 0) {
            try {
              delete res[keyBundle][kindProduct];
            } catch (err) {
              // console.log(err)
            }
          } else {
            childKeys.forEach((key) => {
              let servicesOfThisDevice = lastservices[key];
              // checking if we have to add it
              const alreadyHasThisRecomendation = servicesOfThisDevice.find(
                (hiredService) => hiredService.id === service.serviceId
              );
              if (!alreadyHasThisRecomendation) {
                const service2Add = {
                  ...service,
                  status: THIRDPARTY_STATUS.RECOMMENDED,
                };
                servicesOfThisDevice = [...servicesOfThisDevice, service2Add];
                servicesOfThisDevice = addUsefulDataToServices(
                  servicesOfThisDevice,
                  kindProduct,
                  currentBundle,
                  key
                );
                if (!res[currentBundle.productId]) {
                  res[currentBundle.productId] = {};
                }
                if (!res[currentBundle.productId][kindProduct]) {
                  res[currentBundle.productId][kindProduct] = {};
                }
                if (res[currentBundle.productId][kindProduct][key]) {
                  res[currentBundle.productId][kindProduct][key] = [];
                }
                if (servicesOfThisDevice) {
                  res[currentBundle.productId][kindProduct][key] =
                    servicesOfThisDevice;
                }
              }
            });
          }
        }
      });
    }
  });
  /* NO DEPENDENCY HANDLER */
  if (!res[ISOLATED]) {
    res[ISOLATED] = [];
  }
  RECOMMENDED_THIRDSERVICE.forEach((itemRecommended) => {
    const { kindProduct } = itemRecommended;
    const currentNoDependencyList = thirdPartiesList[ISOLATED];
    const noExist = currentNoDependencyList.find(
      (item) => item.serviceId === itemRecommended.service.serviceId
    );
    if (!kindProduct && !noExist) {
      const newItem2Add = addUsefulDataToServices(
        [{ ...itemRecommended.service }],
        kindProduct,
        // no allows any bundle
        "",
        // productId 0
        `${itemRecommended.service.serviceId}`
      );
      if (newItem2Add && newItem2Add.length > 0) {
        res[ISOLATED].push(newItem2Add[0]);
      }
    }
  });
  return res;
};

export const appendServicesToProducts = (
  thirdpartiesNormalized,
  hiredProductsFromStore
) => {
  const res = [];
  const keyBundles = hiredProductsFromStore.map((bundle) => bundle.productId);

  keyBundles.forEach((keyBundle) => {
    const currentBundle = hiredProductsFromStore.find(
      (bundle) => bundle.productId === keyBundle
    );
    const currentThirdServicesList = thirdpartiesNormalized[keyBundle];

    const keysthird = currentThirdServicesList
      ? Object.keys(currentThirdServicesList)
      : [];
    // itero por tv, mobile, internet, phone
    keysthird.forEach((kind) => {
      const currentThirdService = thirdpartiesNormalized[keyBundle][kind];
      const keyOfCurrentThirdService = Object.keys(currentThirdService);
      // itero por cada hijo
      keyOfCurrentThirdService.forEach((itemProductId) => {
        const services2Add =
          thirdpartiesNormalized[keyBundle][kind][itemProductId];
        // KIND MOBILE
        if (kind === "mobile") {
          let currentLinesMobile = currentBundle.mobile.linesMobile;
          currentLinesMobile = currentLinesMobile.map((mobileItem) => {
            let tinyItemRes = mobileItem;
            if (mobileItem.productId === itemProductId) {
              tinyItemRes = {
                ...mobileItem,
                services: services2Add,
              };
            }
            return tinyItemRes;
          });
          // assign the new linesMobile structure
          currentBundle.mobile.linesMobile = currentLinesMobile;
        }
        // KIND INTERNET
        if (kind === "internet") {
          currentBundle.internet.services = services2Add;
        }
        // KIND TV
        if (kind === "tv") {
          currentBundle.tv.services = services2Add;
        }
        // KIND PHONES
        if (kind === "phone") {
          let currentLinesPhones = currentBundle.phone.linesPhone;
          currentLinesPhones = currentLinesPhones.map((phoneItem) => {
            let tinyItemRes = phoneItem;
            if (phoneItem.productId === itemProductId) {
              tinyItemRes = {
                ...phoneItem,
                services: services2Add,
              };
            }
            return tinyItemRes;
          });
          // assign the new linesMobile structure
          currentBundle.phone.linesPhone = currentLinesPhones;
        }
      });
    });
    res.push(currentBundle);
  });
  return res;
};

export const addIsolatedServices = (svaList, isolated) => {
  if (isolated && isolated.length > 0) {
    isolated.forEach((item) => {
      svaList.push(item);
    });
  }
  return svaList;
};

export const createServiceSlider = (
  thirdpartiesNormalized,
  newHiredProducts
) => {
  const res = {};
  const bundleKeys = Object.keys(thirdpartiesNormalized);
  /* ONLY WORKS WHEN HAS SOME SERVICE ON EVERY BUNDLE */
  bundleKeys.forEach((bundleId) => {
    if (bundleId !== ISOLATED) {
      res[bundleId] = [];
      const currentBundle = thirdpartiesNormalized[bundleId];
      const kindProductKeys = Object.keys(currentBundle);
      kindProductKeys.forEach((kindKey) => {
        const childId = thirdpartiesNormalized[bundleId][kindKey];
        const childKeysId = Object.keys(childId);
        childKeysId.forEach((childKey) => {
          const servicesOfThisDevice =
            thirdpartiesNormalized[bundleId][kindKey][childKey];
          servicesOfThisDevice.forEach((serviceOfthis) => {
            const haveThisServiceStored = res[bundleId].find(
              (service) => service.serviceId === serviceOfthis.serviceId
            );
            const thisIsShowOnSlider =
              serviceOfthis.serviceId !==
                THIRDPARTIES_LIBRARY.netflix.serviceId &&
              serviceOfthis.serviceId !==
                THIRDPARTIES_LIBRARY.nubico.serviceId &&
              serviceOfthis.serviceId !==
                THIRDPARTIES_LIBRARY.identificadorDeLlamasFijo.serviceId;
            if (!haveThisServiceStored && thisIsShowOnSlider) {
              res[bundleId].push(serviceOfthis);
            }
          });
        });
      });
      // Dont forgett add aisolated products when bundleid !== ISOLATED
      res[bundleId] = addIsolatedServices(
        res[bundleId],
        thirdpartiesNormalized[ISOLATED]
      );
    }
  });
  /* THE CLIENT ONLY HAS ISOLATED SERVICES */
  const isolated = thirdpartiesNormalized[ISOLATED];
  const onlyIsolated = bundleKeys.length === 1 && bundleKeys[0] === ISOLATED;
  if (onlyIsolated && isolated && isolated.length > 0) {
    newHiredProducts.forEach((bundle) => {
      const bundleId = bundle.productId;
      const isolatedList = addIsolatedServices([], isolated);
      if (isolatedList.length > 0) {
        res[bundleId] = isolatedList;
      }
    });
  }
  return res;
};

export const getGamePassActivationCodeDataResponseNormalizer = (
  response,
  productId
) => {
  let gamePassActivationCodeDataNormalized = null;
  if (response) {
    gamePassActivationCodeDataNormalized = response;
    gamePassActivationCodeDataNormalized.productId = productId;
  }
  return gamePassActivationCodeDataNormalized;
};

export const normalizeThirdServices = (response) => {
  return response;
};

export const normalizeUrlActivateNetflix = (response) => {
  const urlActivacionNetflix = response;
  return urlActivacionNetflix;
};

/**
 * Method that return an Object with devicesID keys
 * @param {array} devices
 */
export const normalizeGetDevicesConnectedSmartWiFiResponse = (devices) => {
  const devicesObj = devices.reduce((acc, item) => {
    acc[item.device_id] = { ...item, fetching: false, error: false };
    return acc;
  }, {});
  return devicesObj;
};

/**
 * Method that return an Object with products name and linesPhones as keys
 * @param {array} devices
 */
export const getPhoneByHiredProductsAndProductId = ({
  hiredProductsData,
  productId,
}) => {
  if (hiredProductsData && productId) {
    const bundle = getProductAndDadByProductId(hiredProductsData, productId);
    let product = null;
    if (bundle?.product) {
      product = getProductById(hiredProductsData, bundle.dadId);
    } else {
      product = product = getProductById(hiredProductsData, productId);
    }
    return product?.phone?.linesPhone?.[0].number;
  }
  return null;
};

export const checkItemInArray = ({ items, phone }) => {
  if (items && Array.isArray(items) && items.length > 0) {
    const urlExist = items.filter((item) => item.phone === phone);
    return urlExist ? true : false;
  }
  return false;
};

export const checkSmartWifiDevice = ({ smartWifiDevice, phone }) => {
  return smartWifiDevice && smartWifiDevice?.[phone] ? true : false;
};

export const providerCompatibilityNormalizer = (data, provider, productId) => {
  if (data && provider) {
    if (
      provider === "disney" &&
      data &&
      Array.isArray(data.compatibles) &&
      data.compatibles.length > 0 &&
      data.compatibles[0].estado === "A"
    ) {
      data.url = DISNEY_LOGIN_URL;
    } else {
      data.url = `${PROVIDER_ACTIVATION_URL}?provider=${provider}`;
    }
  }
  return data;
};

export const compatibilityDisneyDataNormalizer = (data) => {
  if (data) {
    data.url = DISNEY_ACTIVATION_DPROVIDER_ACTIVATION_URL;
  }
  return data;
};

export const getUrlParamProvider = (provider) => {
  let ott = null;
  if (provider) {
     switch (provider) {
        case PROVIDER_ID_DAZN: 
          ott = "dazn";
          break;   
        case PROVIDER_ID_DISNEY: 
          ott = "disney";
          break;  
        case PROVIDER_ID_MAX:
          ott = "max";
          break;  
        case PROVIDER_ID_APPLETV:
          ott = "appletv";
          break;  
        case PROVIDER_ID_SKY:
          ott = "sky";
          break;  
        default: break;
      }
  }
  return ott
}
